import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as SidebarActions } from "../../store/ducks/sidebar";
import { Creators as PropostaAlertasActions } from "../../store/ducks/propostasAlertas";
import { Creators as AtendimentoActions } from "../../store/ducks/atendimento";
import { Creators as BuscaClienteActions } from "../../store/ducks/buscaCliente";
import { Creators as AuthActions } from "../../store/ducks/auth";
import { Creators as LoadingActions } from "../../store/ducks/loading";
import { Creators as PermissionsActions } from "../../store/ducks/permissions";
import { Creators as AgendamentosActions } from "../../store/ducks/agendamentos";
import { Creators as ErrorActions } from "../../store/ducks/error";
import { Creators as SuccesImportacoesActions } from "../../store/ducks/successImportacoes";
import { Creators as UsuariosActions } from "../../store/ducks/usuarios";
import { Creators as StorePageActions } from "../../store/ducks/PageStores/usuariosStores";
import { Creators as MenuActions } from "../../store/ducks/menu";
import { Creators as ContentActions } from "../../store/ducks/content";
import { Creators as CalculadoraActions } from "../../store/ducks/calculadora";
import SettingsButton from "@material-ui/icons/Settings";
import MainAppBar from "../MainAppBar";
import { Container, Flex } from "./styles.js";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import NotificationButton from "@material-ui/icons/Notifications";
import HeadsetButton from "@material-ui/icons/HeadsetMic";
import MailButton from "@material-ui/icons/MailOutline";
import SearchButton from "@material-ui/icons/Search";
import TextFormatButton from "@material-ui/icons/TextFormat";
import OpenedButton from "@material-ui/icons/Drafts";
import NotOpenedButton from "@material-ui/icons/Mail";
import Badge from "@material-ui/core/Badge";
import { NavLink } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Modal from "@material-ui/core/Modal";
import api from "../../services/api";
import SearchIcon from "@material-ui/icons/Search";
import InfoIcon from "@material-ui/icons/Info";
import { withRouter } from "react-router";
import CalendarButton from "@material-ui/icons/Event";
import moment from "moment";
import Atendimento from "../Atendimento";
import Avatar from "@material-ui/core/Avatar";
import AvatarImg from "../../assets/avatar.png";
import SenhaForm from "../../components/Forms/Usuarios/senha";
import { Creators as ModalPhotoActions } from "../../store/ducks/modalPhoto";
import PhotoForm from "../../components/Forms/Usuarios/photo";
import MenuHorizontal from "../MenuHorizontal";
import ViewQuiltButton from "@material-ui/icons/ViewQuilt";
import FormatIndentDecreaseButton from "@material-ui/icons/FormatIndentDecrease";
import FormatIndentIncreaseButton from "@material-ui/icons/FormatIndentIncrease";
import ChatIcon from "../../components/ChatIcon";
import { Provider } from "react-redux";
import store from "../../storeChat";
import apiChat from "../../services/apiChat";

class HeaderMenuHorizontal extends Component {
  state = {
    anchorEl: null,
    anchorElAlerts: null,
    anchorElComunicados: null,
    anchorElPesquisador: null,
    anchorElConfigs: null,
    anchorElAgendamentos: null,
    anchorElPropostasAlertas: null,
    openComunicado: false,
    comunicado: {},
    comunicadosNaoLidos: [],
    totalAgendamentos: 0,
    modalSenha: false,
    anchorElChat: null,
    loadingInstallChat: false,
  };

  handleSenha = () => {
    this.setState({
      modalSenha: true,
    });
    this.handleClose();
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleClickAlerts = (event) => {
    this.setState({ anchorElAlerts: event.currentTarget });
  };

  handleCloseAlerts = () => {
    this.setState({ anchorElAlerts: null });
  };

  handleClickComunicados = (event) => {
    this.setState({ anchorElComunicados: event.currentTarget });
  };

  handleCloseComunicados = () => {
    this.setState({ anchorElComunicados: null });
  };

  handleOpenModalComunicado = () => {
    this.setState({ openComunicado: true });
  };

  handleCloseModalComunicado = () => {
    this.setState({ openComunicado: false });
  };

  handleClickPesquisador = (event) => {
    this.setState({ anchorElPesquisador: event.currentTarget });
  };

  handleClosePesquisador = () => {
    this.setState({ anchorElPesquisador: null });
  };

  handleClickAgendamentos = (event) => {
    this.setState({ anchorElAgendamentos: event.currentTarget });
  };

  handleCloseAgendamentos = () => {
    this.setState({ anchorElAgendamentos: null });
  };

  handleClickPropostasEmAlerta = (event) => {
    this.setState({ anchorElPropostasAlertas: event.currentTarget });
  };

  handleClosePropostasEmAlerta = () => {
    this.setState({ anchorElPropostasAlertas: null });
  };

  handleClickUpFont = () => {
    let size = localStorage.getItem("@ecorban-app:font-size")
      ? localStorage.getItem("@ecorban-app:font-size")
      : 10;
    if (size < 12) {
      size = parseFloat(size) + 0.5;
      localStorage.setItem("@ecorban-app:font-size", size);
      document.getElementsByTagName("html")[0].style.fontSize = size + "px";
    }
  };

  handleClickDownFont = () => {
    let size = localStorage.getItem("@ecorban-app:font-size")
      ? localStorage.getItem("@ecorban-app:font-size")
      : 10;
    if (size > 8.5) {
      size = parseFloat(size) - 0.5;
      localStorage.setItem("@ecorban-app:font-size", size);
      document.getElementsByTagName("html")[0].style.fontSize = size + "px";
    }
  };

  handleCountPropostasAlerta = () => {
    this.props.setAction("COUNT");
    this.props.getPropostasAlertasCount();
  };

  handleOpenComunicado = (id, opened) => {
    this.props.setLoading();
    this.handleCloseComunicados();
    api
      .patch(`/communications/${id}/open`)
      .then((data) => {
        this.props.unsetLoading();
        this.setState({ comunicado: data.data, openComunicado: true });
        this.props.getPermissions();
        if (opened === 0) {
          this.setState({
            comunicadosNaoLidos: this.state.comunicadosNaoLidos - 1,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.props.unsetLoading();
      });
  };

  setNotReady = () => {
    let comunicadosNaoLidos = this.props.comunicados.filter(
      (comunicado) => comunicado.opened === 0
    );
    this.setState({
      comunicadosNaoLidos: comunicadosNaoLidos.length,
    });
  };

  handleClickConfigs = (event) => {
    this.setState({ anchorElConfigs: event.currentTarget });
  };

  handleCloseConfigs = () => {
    this.setState({ anchorElConfigs: null });
  };

  componentDidMount() {
    this.handleCountPropostasAlerta();
    this.props.getAgendamentos();
    let self = this;
    setInterval(function () {
      self.props.getPermissions();
      self.props.getAgendamentos();
      self.setNotReady();
    }, 900000);
    this.setNotReady();

    if (this.handlePermissions("ATENDER CLIENTE")) {
      this.props.getAtendimento();
    }

    // REMOVER ISSO
    if (this.props.comunicados.length > 0) {
      if (
        this.props.comunicados[0].featured === 1 &&
        !this.props.comunicados[0].opened
      ) {
        this.handleOpenComunicado(
          this.props.comunicados[0].id,
          this.props.comunicados[0].opened
        );
      }
    }

    if (this.props.permissions.notifications.length > 0) {
      this.props.openSuccessImportacoes(
        `${this.props.permissions.notifications[0].name} - ${this.props.permissions.notifications[0].message}`
      );

      api
        .get(`/notifications/${this.props.permissions.notifications[0].id}`)
        .then((data) => {
          // TODO
        })
        .catch((err) => {
          console.log(err);
          this.props.unsetLoading();
        });
    }
  }

  componentDidUpdate(prevState, prevProps) {
    let pivot = 0;
    this.props.agendamentos.forEach((agendamento) => {
      agendamento.data.forEach((call) => {
        if (moment(call.data) <= moment() && call.completed !== 1) {
          pivot++;
        }
      });
    });
    if (prevProps.totalAgendamentos !== pivot) {
      this.setState({
        totalAgendamentos: pivot,
      });
    }
  }

  handlePermissions = (permission) => {
    return this.props.permissions.data.indexOf(permission) > -1 ||
      this.props.master
      ? true
      : false;
  };

  handlePhoto = (id) => {
    this.props.setAction("PHOTO");
    this.props.getUsuarios(id);
    this.handleClose();
  };

  handleClickChat = (event) => {
    this.setState({ anchorElChat: event.currentTarget });
  };

  handleCloseChat = () => {
    this.setState({ anchorElChat: null });
  };

  installChat = async () => {
    try {
      this.setState({
        loadingInstallChat: true,
      });

      const tenant = await api.get("/company");

      const customerName = tenant.data.name;
      const customerEmail = tenant.data.resp_email
        ? tenant.data.resp_email
        : `${tenant.data.name.toLowerCase().replace(/ /g, "")}@mail.com`;
      const customerPassword = `${tenant.data.id}#54578`;

      const customer = await apiChat.post("/customers", {
        name: customerName,
        email: customerEmail,
        password: customerPassword,
      });

      const users = await api.get(
        "/users?page=1&&per_page=9999999999999999999&&login_blocked=false"
      );

      const usersInsert = users.data.data.map((user) => ({
        name: user.name,
        customer: customer.data._id,
        id_in_customer: user.id,
        avatar: user.avatar,
        email: `${tenant.data.id}${user.id}${customerEmail}`,
        key: customer.data.key,
        password: `${tenant.data.id}${user.id}#54578`,
        active: true,
      }));

      await apiChat.post("/users", usersInsert);

      await api.patch("/company/chat-key", { chat_key: customer.data.key });

      this.setState({
        loadingInstallChat: false,
        chatDone: true,
      });
    } catch (err) {
      this.setState({
        loadingInstallChat: false,
      });
    }
  };

  render() {
    const tenant = localStorage.getItem("@ecorban-app:tenant");
    const {
      anchorEl,
      // anchorElAlerts,
      anchorElComunicados,
      anchorElPesquisador,
      anchorElAgendamentos,
      anchorElPropostasAlertas,
      anchorElConfigs,
      anchorElChat,
    } = this.state;
    return (
      <Fragment>
        <div className="container-header">
          <Flex>
            {this.props.menu === "horizontal" && (
              <div className="header-horizontal">
                <div className="drawerHeader">
                  <Avatar
                    aria-owns={anchorEl ? "simple-menu" : null}
                    onClick={this.handleClick}
                    className="cursor-pointer avatar-header"
                    src={this.props.avatar ? this.props.avatar : AvatarImg}
                  />
                  <div className="dados-usuario">
                    <p className="nome-usuario truncate-name">
                      {this.props.name}
                      <span className="truncate-name">
                        {this.props.company}
                      </span>
                      <small>Online</small>
                    </p>
                  </div>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                    className="menu-suspenso"
                  >
                    {this.props.master && (
                      <NavLink to={`/${tenant}/empresa`}>
                        <MenuItem>
                          <i className="fa fa-building-o mr1" />
                          Empresa
                        </MenuItem>
                      </NavLink>
                    )}
                    <MenuItem
                      onClick={() => {
                        this.handlePhoto(this.props.id);
                      }}
                    >
                      <i className="fa fa-camera mr1" />
                      Foto
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.handleSenha();
                      }}
                    >
                      <i className="fa fa-key mr1" />
                      Alterar Senha
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        this.props.logout();
                      }}
                    >
                      <i className="fa fa-sign-out mr1" />
                      Sair
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            )}
            <div>
              <Container id="topo">
                {this.props.menu === "vertical" && (
                  <Button
                    variant="contained"
                    className="hamburguer"
                    onClick={() =>
                      this.props.open
                        ? this.props.closeSideBar()
                        : this.props.openSideBar()
                    }
                  >
                    <i className="fa fa-bars" />
                  </Button>
                )}
                <Fragment>
                  {this.handlePermissions("PESQUISAR CLIENTE") && (
                    <div className="busca-header">
                      <SearchIcon className="search-icon" />
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (
                            document.getElementById("busca-cliente-header")
                              .value.length > 3
                          ) {
                            this.props.buscaClienteAction(
                              document.getElementById("busca-cliente-header")
                                .value
                            );
                            this.props.history.push(
                              `/${tenant}/central-de-atendimento`
                            );
                            document
                              .getElementById("busca-cliente-header")
                              .classList.remove("error");
                          } else {
                            this.props.openError(
                              "Sua busca deve conter mais de 3 caracteres."
                            );
                            document
                              .getElementById("busca-cliente-header")
                              .classList.add("error");
                          }
                        }}
                      >
                        <input
                          type="text"
                          id="busca-cliente-header"
                          placeholder="Pesquisar cliente"
                        />
                        {this.handlePermissions("ATENDER CLIENTE") && (
                          <Tooltip
                            disableFocusListener
                            title={`Pesquisar por: nome, CPF, RG, e-mail, cidade, estado`}
                            classes={{ tooltip: "tooltip" }}
                            enterDelay={100}
                          >
                            <InfoIcon className="info-icon" />
                          </Tooltip>
                        )}
                      </form>
                    </div>
                  )}
                  {this.handlePermissions("ATENDER CLIENTE") && (
                    <Tooltip
                      disableFocusListener
                      title={`Central de Atendimento`}
                      classes={{ tooltip: "tooltip" }}
                      enterDelay={100}
                    >
                      <NavLink to={`/${tenant}/central-de-atendimento`}>
                        <IconButton className="ml1 badge-button">
                          <HeadsetButton />
                        </IconButton>
                      </NavLink>
                    </Tooltip>
                  )}
                  {((!!this.props.pesquisador_module &&
                    !!this.props.pesquisador) ||
                    !!this.props.super_user) && (
                    <Fragment>
                      <div className="divisoria-header" />
                      <Tooltip
                        disableFocusListener
                        title={`Pesquisador`}
                        classes={{ tooltip: "tooltip" }}
                        enterDelay={100}
                      >
                        <IconButton
                          className="badge-button "
                          onClick={this.handleClickPesquisador}
                        >
                          <SearchButton />
                        </IconButton>
                      </Tooltip>

                      <Menu
                        id="simple-menu-pesquisador"
                        anchorEl={anchorElPesquisador}
                        open={Boolean(anchorElPesquisador)}
                        onClose={this.handleClosePesquisador}
                        className="menu-suspenso"
                      >
                        <NavLink to={`/${tenant}/dados-cadastrais`}>
                          <MenuItem onClick={this.handleClosePesquisador}>
                            Dados Cadastrais
                          </MenuItem>
                        </NavLink>
                        <NavLink to={`/${tenant}/consignado-inss`}>
                          <MenuItem onClick={this.handleClosePesquisador}>
                            Consignado INSS
                          </MenuItem>
                        </NavLink>
                      </Menu>
                    </Fragment>
                  )}
                  <div className="divisoria-header" />
                </Fragment>
                <Tooltip
                  disableFocusListener
                  title={`Calculadora Simulador Livre`}
                  classes={{ tooltip: "tooltip" }}
                  enterDelay={100}
                >
                  <IconButton
                    className="badge-button "
                    onClick={() => this.props.openCalculadoraFc()}
                  >
                    <i className="fa fa-calculator" />
                  </IconButton>
                </Tooltip>
                <div className="ml-auto">
                  {this.props.chat_key || this.props.master ? (
                    <Fragment>
                      <Provider store={store}>
                        <ChatIcon
                          chat_key={this.props.chat_key}
                          chatDone={this.state.chatDone}
                          handleClickChat={this.handleClickChat}
                        />
                      </Provider>
                      <div className="divisoria-header" />
                      <Menu
                        id="simple-menu-chat"
                        anchorEl={anchorElChat}
                        open={Boolean(anchorElChat)}
                        onClose={this.handleCloseChat}
                        className="menu-suspenso menu-comunicados"
                      >
                        <MenuItem
                          className="opened"
                          style={{ borderBottom: 0 }}
                          onClick={() =>
                            !this.state.loadingInstallChat
                              ? this.installChat()
                              : console.log("")
                          }
                        >
                          {this.state.loadingInstallChat ? (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              Aguarde a instalação do chat{" "}
                              <i
                                className="fa fa-spinner fa-pulse"
                                style={{
                                  marginLeft: "1rem",
                                  fontSize: "1.6rem",
                                }}
                              />
                            </span>
                          ) : (
                            "Clique aqui para instalar o chat no sistema"
                          )}
                        </MenuItem>
                      </Menu>
                    </Fragment>
                  ) : (
                    ""
                  )}
                  <Tooltip
                    disableFocusListener
                    title={`Comunicados`}
                    classes={{ tooltip: "tooltip" }}
                    enterDelay={100}
                  >
                    <IconButton
                      className="badge-button"
                      onClick={this.handleClickComunicados}
                    >
                      {this.state.comunicadosNaoLidos > 0 ? (
                        <Badge
                          badgeContent={this.state.comunicadosNaoLidos}
                          color="secondary"
                          className="badge badge-alert"
                        >
                          <MailButton />
                        </Badge>
                      ) : (
                        <MailButton />
                      )}
                    </IconButton>
                  </Tooltip>
                  <div className="divisoria-header" />
                  <Tooltip
                    disableFocusListener
                    title={`Agendamentos`}
                    classes={{ tooltip: "tooltip" }}
                    enterDelay={100}
                  >
                    <IconButton
                      className="badge-button"
                      onClick={this.handleClickAgendamentos}
                    >
                      {this.props.agendamentos.length > 0 ? (
                        <Badge
                          badgeContent={this.state.totalAgendamentos}
                          color="secondary"
                          className="badge badge-alert"
                        >
                          <CalendarButton />
                        </Badge>
                      ) : (
                        <CalendarButton />
                      )}
                    </IconButton>
                  </Tooltip>
                  <div className="divisoria-header" />
                  <Tooltip
                    disableFocusListener
                    title={`Propostas em alerta`}
                    classes={{ tooltip: "tooltip" }}
                    enterDelay={100}
                  >
                    <NavLink to={`/${tenant}/propostas-alertas`}>
                      <IconButton
                        className="badge-button"
                        // onClick={this.handleClickPropostasEmAlerta}
                      >
                        {this.props.propostasAlertasTotal > 0 ? (
                          <Badge
                            badgeContent={this.props.propostasAlertasTotal}
                            color="secondary"
                            className="badge badge-alert"
                          >
                            <NotificationButton />
                          </Badge>
                        ) : (
                          <NotificationButton />
                        )}
                      </IconButton>
                    </NavLink>
                  </Tooltip>
                  <div className="divisoria-header" />
                  <Tooltip
                    disableFocusListener
                    title={`Configurações do sistema`}
                    classes={{ tooltip: "tooltip" }}
                    enterDelay={100}
                  >
                    <IconButton
                      className="badge-button"
                      onClick={this.handleClickConfigs}
                    >
                      <SettingsButton />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    id="simple-menu-configs"
                    anchorEl={anchorElConfigs}
                    open={Boolean(anchorElConfigs)}
                    onClose={this.handleCloseConfigs}
                    className="menu-suspenso menu-comunicados"
                  >
                    <MenuItem
                      className="opened"
                      onClick={() => {
                        this.props.changeContent(
                          this.props.content === "main-content-small"
                            ? "main-content"
                            : "main-content-small"
                        );
                        localStorage.setItem(
                          "@ecorban-app:content",
                          this.props.content === "main-content-small"
                            ? "main-content"
                            : "main-content-small"
                        );
                      }}
                    >
                      <div className="menu-left">
                        {this.props.content === "main-content-small" ? (
                          <IconButton className="text-button">
                            <FormatIndentDecreaseButton />
                          </IconButton>
                        ) : (
                          <IconButton className="text-button">
                            <FormatIndentIncreaseButton />
                          </IconButton>
                        )}
                      </div>
                      <div className="menu-right">
                        {this.props.content === "main-content-small"
                          ? "Aumentar container"
                          : "Diminuir container"}
                      </div>
                    </MenuItem>

                    <MenuItem
                      className="opened"
                      onClick={() => {
                        this.props.changeMenu("vertical");
                        localStorage.setItem("@ecorban-app:menu", "vertical");
                      }}
                    >
                      <div className="menu-left">
                        <IconButton className="icon-button-small text-button">
                          <ViewQuiltButton />
                        </IconButton>
                      </div>
                      <div className="menu-right">
                        Alterar menu para vertical
                      </div>
                    </MenuItem>

                    <MenuItem
                      className="opened"
                      onClick={this.handleClickUpFont}
                    >
                      <div className="menu-left">
                        <IconButton className="text-button">
                          <TextFormatButton />
                        </IconButton>
                      </div>
                      <div className="menu-right">Aumentar fonte</div>
                    </MenuItem>

                    <MenuItem
                      className="opened"
                      onClick={this.handleClickDownFont}
                    >
                      <div className="menu-left">
                        <IconButton className="icon-button-small text-button">
                          <TextFormatButton />
                        </IconButton>
                      </div>
                      <div className="menu-right">Diminuir fonte</div>
                    </MenuItem>
                  </Menu>

                  <Menu
                    id="simple-menu-comunicados"
                    anchorEl={anchorElComunicados}
                    open={Boolean(anchorElComunicados)}
                    onClose={this.handleCloseComunicados}
                    className="menu-suspenso menu-comunicados"
                  >
                    {this.props.comunicados.map((comunicado, index) => (
                      <MenuItem
                        className={comunicado.opened ? "opened" : ""}
                        key={comunicado.id}
                        onClick={() =>
                          this.handleOpenComunicado(
                            comunicado.id,
                            comunicado.opened
                          )
                        }
                      >
                        <div className="menu-left">
                          {comunicado.opened ? (
                            <OpenedButton />
                          ) : (
                            <NotOpenedButton />
                          )}
                        </div>
                        <div className="menu-right">
                          <b className="truncate-comunicado">
                            {comunicado.name}
                          </b>
                          <small>
                            POR: {comunicado.author.name} - {comunicado.sent_at}
                          </small>
                        </div>
                      </MenuItem>
                    ))}
                    {this.props.comunicados.length <= 0 && (
                      <MenuItem className="opened">
                        Não existem comunicados.
                      </MenuItem>
                    )}
                    {this.props.comunicados.length === 5 && (
                      <MenuItem
                        className="see-all"
                        onClick={() => this.props.getFullComunicados()}
                      >
                        Visualizar Todos
                      </MenuItem>
                    )}
                  </Menu>
                  <Menu
                    id="simple-menu-agendamentos"
                    anchorEl={anchorElAgendamentos}
                    open={Boolean(anchorElAgendamentos)}
                    onClose={this.handleCloseAgendamentos}
                    className="menu-suspenso menu-comunicados menu-calendario"
                  >
                    {this.props.agendamentos.map((agendamento) =>
                      agendamento.data
                        .filter(
                          (call) =>
                            moment(call.data) <= moment() &&
                            call.completed !== 1
                        )
                        .map((call) =>
                          call.type === "calls" ? (
                            <MenuItem
                              className="opened"
                              key={`lista-ca-${call.id}`}
                              onClick={() => {
                                this.props.buscaClienteAction(
                                  call.customer_cpf_cnpj
                                );
                                this.handleCloseAgendamentos();
                                this.props.history.push(
                                  `/${tenant}/central-de-atendimento`
                                );
                              }}
                            >
                              <div className="menu-left">
                                <CalendarButton />
                              </div>
                              <div className="menu-right">
                                <b className="truncate-comunicado">
                                  ATENDIMENTO {call.customer_name.toUpperCase()}
                                </b>
                                <small>
                                  Em:{" "}
                                  {moment(call.date).format("DD/MM/YYYY HH:mm")}
                                  h
                                </small>
                              </div>
                            </MenuItem>
                          ) : (
                            <NavLink to={`/${tenant}/calendario`}>
                              <MenuItem
                                className="opened"
                                key={`lista-ca-${call.id}`}
                                onClick={() => this.handleCloseAgendamentos()}
                              >
                                <div className="menu-left">
                                  <CalendarButton />
                                </div>
                                <div className="menu-right">
                                  <b className="truncate-comunicado">
                                    {call.type_name.toUpperCase()} -{" "}
                                    {call.name.toUpperCase()}
                                  </b>
                                  <small>
                                    Em:{" "}
                                    {moment(call.date).format(
                                      "DD/MM/YYYY HH:mm"
                                    )}
                                    h
                                  </small>
                                </div>
                              </MenuItem>
                            </NavLink>
                          )
                        )
                    )}
                    {this.props.agendamentos.length <= 0 && (
                      <NavLink to={`/${tenant}/calendario`}>
                        <MenuItem
                          className="opened not-border-bottom"
                          onClick={() => this.handleCloseAgendamentos()}
                        >
                          Não existem agendamentos pendentes.
                        </MenuItem>
                      </NavLink>
                    )}
                    {this.props.agendamentos.length > 0 && (
                      <NavLink
                        className="not-border-bottom"
                        to={`/${tenant}/calendario`}
                      >
                        <MenuItem
                          className="see-all"
                          onClick={() => this.handleCloseAgendamentos()}
                        >
                          Ir para calendário completo
                        </MenuItem>
                      </NavLink>
                    )}
                  </Menu>
                  <Menu
                    id="simple-menu-propostas-alertas"
                    anchorEl={anchorElPropostasAlertas}
                    open={Boolean(anchorElPropostasAlertas)}
                    onClose={this.handleClosePropostasEmAlerta}
                    className="menu-suspenso menu-comunicados menu-calendario"
                  >
                    <a
                      class="not-border-bottom"
                      target="_blank"
                      href={`https://ecorban.com/${tenant}`}
                    >
                      <MenuItem
                        className="opened not-border-bottom"
                        onClick={() => this.handleClosePropostasEmAlerta()}
                      >
                        Clique aqui e acesse a nova versão para visualizar essa
                        funcionalidade.
                      </MenuItem>
                    </a>
                  </Menu>
                </div>
                <Modal
                  open={this.state.openComunicado}
                  onClose={this.handleCloseModalComunicado}
                  className="modal"
                >
                  <div>
                    <div className="modalHeader">
                      {this.state.comunicado.name}
                    </div>
                    <div
                      className="modalBody"
                      dangerouslySetInnerHTML={{
                        __html: this.state.comunicado.communication,
                      }}
                    />
                  </div>
                </Modal>
                <Modal
                  open={this.state.modalSenha}
                  onClose={() => this.setState({ modalSenha: false })}
                  className="modal"
                >
                  <div>
                    <div className="modalHeader">Alterar senha</div>
                    <div className="modalBody">
                      <SenhaForm
                        closeModalSenha={() =>
                          this.setState({ modalSenha: false })
                        }
                      />
                    </div>
                  </div>
                </Modal>
                <Modal
                  open={this.props.modalPhoto.open}
                  onClose={() => this.props.closePhotoModal()}
                  className="modal"
                >
                  <div>
                    <div className="modalHeader">
                      Foto do usuário{" "}
                      {this.props.usuarios.item.name
                        ? this.props.usuarios.item.name.toUpperCase()
                        : ""}
                    </div>
                    <div className="modalBody">
                      <PhotoForm />
                    </div>
                  </div>
                </Modal>
              </Container>
              <div className="null-bar">
                <ul>
                  {this.handlePermissions("VISUALIZAR DASHBOARD") && (
                    <li>
                      <NavLink to={`/${tenant}/dashboard`}>
                        <i className="fa fa-tachometer" /> Dashboard
                      </NavLink>
                    </li>
                  )}
                  {this.handlePermissions("LISTAR CLIENTES") && (
                    <li>
                      <NavLink to={`/${tenant}/clientes`}>
                        <i className="fa fa-users" /> Clientes
                      </NavLink>
                    </li>
                  )}
                  {this.handlePermissions("LISTAR PROPOSTAS") && (
                    <li>
                      <NavLink to={`/${tenant}/propostas`}>
                        <i className="fa fa-copy" /> Propostas
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </Flex>
          <MenuHorizontal />
          <MainAppBar style={{ height: "4.8rem;" }} />
        </div>
        <Atendimento />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.sidebar.open,
  propostasAlertasTotal: state.propostasAlertas.count,
  master: state.permissions.master,
  comunicados: state.permissions.comunicados,
  permissions: state.permissions,
  pesquisador_module: state.permissions.pesquisador_module,
  pesquisador: state.permissions.pesquisador,
  super_user: state.permissions.super_user,
  agendamentos: state.agendamentos.agendamentos.filter(
    (agendamento) => agendamento.total > 0
  ),
  menu: state.menu.disposicao,
  avatar: state.permissions.avatar,
  name: state.permissions.name,
  company: state.permissions.company,
  usuarios: state.usuarios,
  modalPhoto: state.modalPhoto,
  id: state.permissions.id,
  content: state.content.disposicao,
  calculadora: state.calculadora,
  chat_key: state.permissions.chat_key,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...SidebarActions,
      ...AuthActions,
      ...PropostaAlertasActions,
      ...LoadingActions,
      ...PermissionsActions,
      ...BuscaClienteActions,
      ...AtendimentoActions,
      ...ErrorActions,
      ...AgendamentosActions,
      ...SuccesImportacoesActions,
      ...ModalPhotoActions,
      ...UsuariosActions,
      ...StorePageActions,
      ...MenuActions,
      ...ContentActions,
      ...CalculadoraActions,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderMenuHorizontal)
);



// WEBPACK FOOTER //
// ./src/components/HeaderMenuHorizontal/index.js